var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('stat-date-range',{on:{"onSearch":_vm.search,"onClear":_vm.clearFilter}}),_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }